import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from '@material-ui/core/Container';
import Copyright from '../componentes/copyright'
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import logo from './logo.png';
import {authConfig} from '../auth/config';
import {AuthContext} from '../auth/AuthContext';
import React,{useState , useCallback,useContext} from 'react';
import {withRouter,Redirect, Link} from 'react-router-dom';
import { useForm } from "react-hook-form";
import Links from '@material-ui/core/Link';


const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    
    flexGrow: 1,
  },
  
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),

   

  },
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  logo: {
    width:'100px',
    height:'100px',
    
    
  },

  cabeca: {
    marginLeft: theme.spacing(2),
    
    
  },
}));


    export const login = withRouter(({history}) => {

      
      const classes = useStyles();
      const { register, handleSubmit, errors } = useForm();
      
      const handlerLoginEmail = useCallback(       
        async (event) => {
          event.preventDefault();
          var email = document.getElementById('email').value;
          var password = document.getElementById('password').value;
     
          try{
            await authConfig
                  .auth()
                  .signInWithEmailAndPassword(email,password);
                  history.push('/PageInit'); 
          }catch(error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
     
            if (errorCode == 'auth/wrong-password') {
              alert('E-mail e/ou Senha incorretos');
               
            } else {
                alert(errorMessage);
            }
     
          }
        }
        ,
        [history],
      )
       
      ;

      function onSubmit() {
    
      }
    

     const {usuario} = useContext(AuthContext);
  
 
     if(usuario){
        return <Redirect to="/PageInit" />;
      }
      
    
      document.title = 'Frota UFSM - Login'
      document.logo=''
      
        
      
 

  return (

 
      
    <Container component="main" >
      <CssBaseline />
    
      <div className={classes.root}><AppBar position="static">
        <Toolbar>
        
        <img src={logo} className={classes.logo} alt="logo" />
         
        
        <Typography className = {classes.cabeca} component="h1" variant="h5"  >
          Frota UFSM
        </Typography>
          
        </Toolbar>
      </AppBar></div>
      <Container maxWidth="xs">
      <div className={classes.paper}>
      
      
        <Avatar className={classes.avatar} >
         
        </Avatar>
        <Typography component="h1" variant="h5">
         Acesso Restrito
        </Typography>
        <form className={classes.form}  onSubmit={handlerLoginEmail} noValidate={false}>
          <TextField
            variant="outlined"
            margin="normal"
            //onChange={ e=>setEmail(e.target.value)}
            required
            type="mail"
            fullWidth
            id="email"
            label="E-mail"
            name="email"
            autoComplete="signInWithEmailAndPassword"
            autoFocus
            
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            //onInput={ e=>setPassword(e.target.value)}
            name="password"
            label="Senha"
            type="password"
            id="password"
            autoComplete="current-password"
          />
          
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Entrar
          </Button>

          <div  align="center">

          <Links target="_blank" href="https://drive.google.com/file/d/1QA4CC_8NhhawqfW-bZ0MhzF7JwhM3t5y/view?usp=sharing">
                
            Como fazer seu cadastro
         
         
         </Links>
         
         </div>

         
         <br></br>
          <Grid container>
            <Grid item xs>
              <Link to="/resetPassword" >
                Esqueceu a senha?
              </Link>
            </Grid>
            <Grid item>
              <Link to="/cadastro" >
                Não tem uma conta? Cadastre-se
              </Link>
            </Grid>

            
          </Grid>

          
        
        </form>
      </div>
      </Container>
      <Box mt={3}>
        <Copyright />
      </Box>
    </Container>
  );
})

export default login;